import Controller from '@ember/controller';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

class AdminSiteConfigController extends Controller {
  @service api;

  disableSeoWorkerLoading = false;

  /**
   * Updates the model based on the gui action
   * @param e
   */
  @action
  updateSeoWorker(e) {
    this.set('disableSeoWorkerLoading', true);

    this.api.put(`admin/site-config/${this.model.id}`, {
      jsonData: {
        disableSEOWorker: e.checked,
      }
    }).finally(() => {
      this.set('disableSeoWorkerLoading', false);
    });
  }
}

export default AdminSiteConfigController;
